import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL, { IMAGE_URL } from "../config/config";
import "../css/products.css";
function Shop() {
  const [products, setProducts] = useState([]);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

const search = searchParams.get("search");
  const category = searchParams.get("category");

 useEffect(() => {

    let url = `${API_URL}/products`;

    const params = [];

    if (category) {
        params.push(`category=${encodeURIComponent(category)}`);
    }

    if (search) {
        params.push(`search=${encodeURIComponent(search)}`);
    }

    if (params.length > 0) {
        url += `?${params.join("&")}`;
    }

    axios.get(url)
        .then((res) => {
            setProducts(res.data);
        })
        .catch(console.log);

}, [category, search]);

  const handleAddToCart = async (productId) => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user) {
      alert("Please login first");
      navigate("/login");
      return;
    }

    try {
      await axios.post(`${API_URL}/cart`, {
        user_id: user.id,
        product_id: productId,
      });

      alert("Product added to cart");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="products-section">

      <h2>{category ? category : "All Products"}</h2>

      <div className="products-grid">

        {products.map((product) => (

          <div className="product-card" key={product.id}>

            <Link
              to={`/product/${product.id}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={`${IMAGE_URL}${product.image}`}
                alt={product.product_name}
                className="product-image"
              />

              <h3>{product.product_name}</h3>

              <p>{product.category}</p>

              <p className="price">${product.price}</p>
            </Link>

            <button
              className="cart-btn"
              onClick={() => handleAddToCart(product.id)}
            >
              Add To Cart
            </button>

          </div>

        ))}

      </div>

    </div>
  );
}

export default Shop;